import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/order/v2/location_groups/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/order/v2/location_groups`, config),
    fetchAll: (config: AxiosRequestConfig) =>
        api.get(`/order/v2/location_groups/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/order/v2/location_groups/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/order/v2/location_groups`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/order/v2/location_groups/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/order/v2/location_groups/${url.id}`, data, config),
};

export default requests;
